import {
  DATE_NUMERIC,
  DEFAULT_TIME_ZONE,
  formatInTimeZone,
  timeZoneLabel,
  zonedDateOf,
} from '@inflip/shared';

/**
 * 어드민 화면의 시각 표시 기준 = 로그인한 어드민 계정 시간대 (기본 한국).
 * 표의 셀 렌더러처럼 훅을 쓸 수 없는 곳에서도 쓰도록 모듈 값으로 둔다 — 어드민은 탭마다 계정 하나인
 * 클라이언트 전용 SPA 라 안전하다. 값이 바뀌면 AdminAuthProvider 가 화면을 다시 그린다.
 * 계약 날짜(사용 기간·기한)는 이 값이 아니라 주문의 timeZone(계약 시간대)으로 보여 준다.
 */
let current = DEFAULT_TIME_ZONE;

export function setAdminTimeZone(timeZone: string): void {
  current = timeZone;
}

export function adminTimeZone(): string {
  return current;
}

/** '2026. 10. 13. 오후 3:04:05' (toLocaleString('ko-KR') 과 같은 표기) */
export function formatDateTime(at: Date | string, timeZone: string = current): string {
  return formatInTimeZone(at, timeZone, {
    ...DATE_NUMERIC,
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
  });
}

/** '2026. 10. 13.' */
export function formatDate(at: Date | string, timeZone: string = current): string {
  return formatInTimeZone(at, timeZone, DATE_NUMERIC);
}

/** '오후 3:04:05' */
export function formatTime(at: Date | string): string {
  return formatInTimeZone(at, current, { hour: 'numeric', minute: '2-digit', second: '2-digit' });
}

/** 어드민 시간대의 오늘 'YYYY-MM-DD' */
export function todayInAdminZone(): string {
  return zonedDateOf(new Date(), current);
}

/** 계약 시간대가 어드민 시간대와 다를 때만 붙이는 기준 표시 */
export function contractZoneNote(contractTimeZone: string): string {
  return contractTimeZone === current ? '' : ` (${timeZoneLabel(contractTimeZone)} 기준)`;
}
